import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
const Loading = () => <div></div>;

const ServiceHorizon = Loadable({
    loader: () => import('./pages/Service/ServiceHorizon'),
    loading: Loading,
});
const ServiceVerticle = Loadable({
    loader: () => import('./pages/Service/ServiceVerticle'),
    loading: Loading,
});
// const Privacypolicy = Loadable({
//   loader: () => import('./pages/agreement/Privacypolicy'),
//   loading: Loading,
// });
class App extends Component {
  render() {
    return (
        <Router>
            <Switch>
                <Route exact path="/sdkwrap" component={ServiceVerticle}/>
                <Route path="/sdkwrap/service-h" component={ServiceHorizon}/>
                <Route path="/sdkwrap/service-v" component={ServiceVerticle}/>
                {/* <Route path="/sdkwrap/agreement/privacypolicy" component={Privacypolicy}/> */}
            </Switch>
        </Router>
    );
  }
}

export default App;
